import { Helmet } from "react-helmet-async";
import usePageReset from "../hooks/usePageReset";
import structuredData from "../assets/structuredText";

export default function Careers() {
  usePageReset();

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="keywords" content="job opportunity vacancy cultiv" />
        <meta
          name="description"
          content="Join Cultiv and be part of a team that values innovation, integrity, and diversity.
We empower employees to lead change and create an impact. Explore our Careers today"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:url" content="https://cultiv.llc" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          itemProp="image"
          content="https://cultiv.llc/images/metaimg.jpg"
        />
        <link rel="image_src" itemProp="image" href="https://cultiv.llc/images/metaimg.jpg" />
        <meta
          property="og:description"
          content="Join Cultiv and be part of a team that values innovation, integrity, and diversity.
We empower employees to lead change and create an impact. Explore our Careers today"
        />
        <meta property="og:site_name" content="Cultiv LLC" />
        <meta property="og:title" content="Cultiv | Careers" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://cultiv.llc" />
        <meta property="twitter:title" content="Cultiv | Careers" />
        <meta
          property="twitter:description"
          content="Join Cultiv and be part of a team that values innovation, integrity, and diversity.
We empower employees to lead change and create an impact. Explore our Careers today"
        />
        <meta property="twitter:image" content="https://cultiv.llc/images/metaimg.jpg" />
        <link rel="canonical" href="https://cultiv.llc" />
        <script type="application/ld+json">{structuredData}</script>
        <title>Cultiv | Careers</title>
      </Helmet>
      <div className="flex flex-col md:flex-row items-center md:justify-between lg:pt-14 pt-6  md:px-15 lg:px-20 xl:px-30 px-6">
        <div className="flex flex-col gap-16">
          <div className="flex flex-col lg:gap-10 gap-6">
            <h1 className="font-expandedBold text-2xl md:text-4xl md:text-start text-center">
              Join our team and become one of us!
            </h1>
            <div className="flex flex-col lg:flex-row lg:gap-8 gap-6">
              <img
                src="/images/careerIcon.png"
                className="object-contain lg:order-2 order-1"
                alt="Join the cultivators"
                height={387}
                width={433}
              />
              <div className="flex flex-col lg:order-1 order-2">
                <p className="md:text-2xl text-sm text-justify pb-6 xl:pl-20 font-Light">
                  Cultiv has core values that impact its culture and strategy and build a sense of
                  commitment. The company empowers its employees by encouraging innovation and
                  emphasizing that small changes today lead to massive changes tomorrow. Our work
                  relations are based on respect and integrity and embrace diversity. Do you want to
                  be part of our team, leading the change and leaving an impact everywhere?
                </p>
                <h2 className="md:text-2xl text-sm pb-3 lg:pl-20">Email us now at:</h2>
                <a
                  className="md:text-2xl text-lg hover:underline self-center font-Bold"
                  href="mailto:careers@cultiv.llc"
                >
                  careers@cultiv.llc
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
